import config, { FeatureName } from 'config';
import { isSchoolSubdomain } from './subdomain';

export const isFeatureEnabled = (feature: FeatureName, hostname: string = window.location.hostname) => {
  return isSchoolSubdomain(hostname)
    ? config.features[feature].schoolsAppEnabled
    : config.features[feature].appEnabled;
};
